// extracted by mini-css-extract-plugin
module.exports = {"Video":"styles_Video__2bXE2","fadeIn":"styles_fadeIn__bGk3f","Video-player":"styles_Video-player__3GgPi"};